import { useEffect, useMemo, useState } from 'react';
import envReader from '../config/envReader';

interface StyleProps {
  type?: 'inline' | 'url';
  style?: any;
}
export const useStyles = () => {
  const [styles, setStyles] = useState<StyleProps>({});

  useEffect(() => {
    if (envReader.PROD) {
      import('../styles/index.scss?inline').then((style) => {
        setStyles({
          type: 'inline',
          style: style.default,
        });
      });
    } else {
      import('../styles/index.scss?url').then((style) => {
        setStyles({
          type: 'url',
          style: style.default,
        });
      });
    }
  }, []);

  const appStyles = useMemo(() => {
    if (styles.style) {
      return styles.type === 'inline' ? (
        <style>{styles.style}</style>
      ) : (
        <link
          rel="stylesheet"
          href={styles.style}
        />
      );
    }
    return null;
  }, [styles]);

  return appStyles;
};
